import { useEffect, useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { Portal } from '@radix-ui/react-portal';
import { isEmpty } from 'lodash';

import { getAuthBearerValue, getWebStoreApiClient } from '@gn-audio/jss-core';

import Backdrop from '../Backdrop/Backdrop';
import { JabraLoader } from '../JabraLoader/JabraLoader';
import { ClientLocationProvider } from '../MegaMenu/providers/ClientLocationContext';
import { useBasket } from './BasketContext/useBasket';
import Checkout from './common/Checkout';
import Empty from './common/Empty';
import Header from './common/Header';
import MyAccount from './common/MyAccount';

import styles from './Basket.module.css';

const Basket = (): JSX.Element | null => {
  const {
    isBasketOpen,
    isEmailCartOpen,
    closeBasket,
    toggleEmailCart,
    busy,
    basket,
    isMyAccountViewOpen,
  } = useBasket();
  const isBasketEmpty = isEmpty(basket?.product_items);
  const [token, setToken] = useState<string>('');

  useEffect(() => {
    const getToken = async () => {
      try {
        const client = getWebStoreApiClient();
        const result = await client.onTokenAcquired;
        const token = getAuthBearerValue(result);
        setToken(token);
      } catch (error) {
        console.error(error);
      }
    };
    getToken();
  }, []);

  return (
    <RemoveScroll enabled={isBasketOpen} allowPinchZoom>
      <Portal>
        <ClientLocationProvider>
          <div role="dialog" aria-labelledby="modal_basket_title" aria-modal={true}>
            <div
              className={`fixed right-0 top-0 z-50 flex h-[100dvh] bg-white transition-transform duration-500 max-md:w-[90vw] md:w-[32rem]`}
              style={{
                transform: `translateX(${isBasketOpen ? '0' : '100%'})`,
              }}
            >
              {busy && <JabraLoader />}
              <div className={styles.innerContainer}>
                <Header />
                <div className={styles.body}>
                  {isBasketEmpty ? (
                    <Empty />
                  ) : (
                    <>
                      <div
                        className={`absolute z-10 flex h-full w-full transform flex-col items-center justify-center bg-white transition-transform duration-500 ease-in-out ${
                          isMyAccountViewOpen ? 'translate-x-0' : 'translate-x-full'
                        }`}
                      >
                        <MyAccount token={token} />
                      </div>
                      <Checkout className={isMyAccountViewOpen ? 'hidden' : ''} token={token} />
                    </>
                  )}
                </div>
                <Backdrop onClick={toggleEmailCart} isVisible={isEmailCartOpen} />
              </div>
            </div>

            <Backdrop onClick={closeBasket} isVisible={isBasketOpen} />
          </div>
        </ClientLocationProvider>
      </Portal>
    </RemoveScroll>
  );
};

export default Basket;
